"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var vendorEvents = [{
  hidden: 'hidden',
  event: 'visibilitychange',
  state: 'visibilityState'
}, {
  hidden: 'webkitHidden',
  event: 'webkitvisibilitychange',
  state: 'webkitVisibilityState'
}, {
  hidden: 'mozHidden',
  event: 'mozvisibilitychange',
  state: 'mozVisibilityState'
}, {
  hidden: 'msHidden',
  event: 'msvisibilitychange',
  state: 'msVisibilityState'
}, {
  hidden: 'oHidden',
  event: 'ovisibilitychange',
  state: 'oVisibilityState'
}];
var hasDocument = typeof document !== 'undefined';
var isSupported = hasDocument && Boolean(document.addEventListener);

var visibility = function () {
  if (!isSupported) {
    return null;
  }

  for (var i = 0; i < vendorEvents.length; i++) {
    var event = vendorEvents[i];

    if (event.hidden in document) {
      return event;
    }
  } // otherwise it's not supported


  return null;
}();

var PageVisibility =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PageVisibility, _PureComponent);

  function PageVisibility() {
    (0, _classCallCheck2.default)(this, PageVisibility);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PageVisibility).apply(this, arguments));
  }

  (0, _createClass2.default)(PageVisibility, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!isSupported || !visibility) {
        return;
      }

      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.isListening = true;
      document.addEventListener(visibility.event, this.handleVisibilityChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.isListening) {
        return;
      }

      document.removeEventListener(visibility.event, this.handleVisibilityChange);
    }
  }, {
    key: "handleVisibilityChange",
    value: function handleVisibilityChange() {
      var hidden = visibility.hidden,
          state = visibility.state;
      this.props.onChange(document[state], document[hidden]);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.children) {
        return null;
      }

      return _react.default.Children.only(this.props.children);
    }
  }]);
  return PageVisibility;
}(_PureComponent2.default);

PageVisibility.propTypes = {
  children: _propTypes.default.node,
  onChange: _propTypes.default.func.isRequired
};
var _default = PageVisibility;
exports.default = _default;
module.exports = exports.default;